<template>
  <el-dialog :title="getTitle" top="50px" :visible.sync="dailogShow" width="80%" :close-on-click-modal="false" :before-close="handleClose" @open="handleOpen">
    <el-form ref="postForm" :model="postForm" :rules="rules" label-width="100px" class="demo-ruleForm" label-position="right">
      <el-row :gutter="20">
        <el-col :span="24" disabled>
          <el-row>
            <el-col :span="18">
              <el-form-item prop="workTaskName" label="任务名称">
                <el-input v-model="postForm.workTaskName" maxlength="50" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="isAuditByParent" label-width="10px" label="">
                <el-checkbox v-model="postForm.isAuditByParent" :disabled="postForm.auditingType>0">提交父审</el-checkbox>              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item prop="beginDate" label="任务期间">
                <el-date-picker
                  v-model="postForm.beginendDateArr"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  type="datetimerange"
                  clearable
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-ddTHH:mm:ss"
                  :default-time="['08:00:00', '17:00:00']"
                  @change="handleDateChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="workTaskStatusDictKey" label-width="5px">
                <el-radio-group v-model="postForm.fangAnStatusDictKey">
                  <el-radio v-for="item in getComboxData('D94')" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item prop="leaderId" label="负责人" placeholder="选择负责人">
                <el-select v-model="postForm.leaderId" :disabled="postForm.auditingType>0" clearable>
                  <el-option v-for="item in memberList.filter(item=>item.userIdentityKey>0)" :key="item.id" :value="item.id" :label="item.userName" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item prop="workTaskMemberList" label="参与人员">
                <el-select v-model="postForm.workTaskMemberList" multiple placeholder="请选择参与人员">
                  <el-option v-for="item in memberList" :key="item.id" :value="item.id" :label="item.userName" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="任务描述" prop="workTaskDescribe">
                <el-input v-model="postForm.workTaskDescribe" :maxlength="1000" type="textarea" :rows="7" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="任务状态" prop="workTaskStatusDictKey">
                <el-radio-group v-model="postForm.workTaskStatusDictKey" :disabled="postForm.auditingType>0">
                  <el-radio-button v-for="(item,idx) in getComboxData('D91')" :key="idx" :label="item.value">{{ item.label }}</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="附件">
                <WorkTaskFile
                  v-model="fileList"
                  :is-can-edit="true"
                  :module-code="moduleCode"
                  :module-key="moduleKey"
                  :task-id="entityId"
                  file-type="D9601"
                />
              </el-form-item>
            </el-col>
          </el-row>

        </el-col>

      </el-row>
      <div class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSave()">保 存</el-button>
      </div>
    </el-form>

  </el-dialog>
</template>

<script>
import pathReq from '@/api/pathlist'
// import Combox from '@/views/managesystem/gz/com/Combox'
import KxjCom from '@/utils/kxjcom'
// import WorkTaskExtra from './WorkTaskExtra'
import WorkTaskFile from './WorkTaskFile'
export default {
  components: {
    // Combox
    // WorkTaskExtra,
    WorkTaskFile
  },
  props: {
    entityId: { type: Number, default: null },
    parentId: { type: Number, default: null },
    moduleCode: { type: String, default: '' },
    moduleKey: { type: Number, default: null }
  },
  data() {
    return {
      dailogShow: false,
      allComboxData: [],
      postForm: {},
      parentTitle: [],
      memberList: [],
      activeName: 'first',
      disContent: '',
      disList: [],
      operLogList: [],
      rules: {
        workTaskName: [
          { required: true, message: '请输入任务名称', trigger: 'change,blur' }
        ],
        beginDate: [
          { required: true, message: '请选择任务期间', trigger: 'change,blur' }
        ],
        leaderId: [
          { required: true, message: '请选择负责人', trigger: 'change,blur' }
        ],
        workTaskMemberList: [
          { required: true, message: '请选择参与者', trigger: 'change,blur' }
        ],
        workTaskStatusDictKey: [
          { required: true, message: '请选择状态', trigger: 'change,blur' }
        ]
      },
      checkInfo: {},
      allTempFiles: [],
      fileList: []
    }
  },
  /** 计算 */
  computed: {
    isEdit() {
      return !!this.entityId
    },
    getTitle() {
      var ret = (this.entityId ? '[编辑]' : '[新增]') + '课题/任务:'
      if (this.parentTitle && this.parentTitle.length > 0) {
        ret += this.parentTitle.join('/')
      } else {
        ret += '任务详情'
      }
      return ret
    }
  },
  /** 创建 */
  created() {
    const that = this
    // 取得所有下拉框数据 逗号隔开
    pathReq.getComboxDatasByIdArray('D86;D87;D91;D94').then(res => {
      that.allComboxData = res.data.result
    })
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter((item) => {
        return item.typeId === typeId
      })
    },
    show() {
      this.dailogShow = true
    },
    handleClose() {
      this.$refs['postForm'].resetFields()
      // this.$refs.formExtra.clearData()
      this.dailogShow = false
    },
    handleOpen() {
      const that = this
      let path = '/api/services/app/WorkTask/GetEditWorkTask'
      path += '?ModuleCode=' + this.moduleCode
      path += '&ModuleKey=' + this.moduleKey

      if (this.entityId) {
        path += '&Id=' + this.entityId
      }
      if (this.parentId) {
        path += '&ParentId=' + this.parentId
      }
      const loading = this.$loading(KxjCom.loadOptions)
      pathReq.getNoParams(path).then(res => {
        that.postForm = res.data.result.entityData
        that.parentTitle = res.data.result.parentTitle
        that.checkInfo = res.data.result.check01
        that.memberList = res.data.result.memberList
        that.allTempFiles = res.data.result.workTaskFiles
        that.fileList = that.allTempFiles.filter(x => x.filetype === 'D9601')
        // 日期范围赋值
        if (this.postForm.id) {
          if (that.postForm.beginDate && that.postForm.endDate) {
            // that.postForm.beginendDateArr
            var dateRange = [
              that.postForm.beginDate,
              that.postForm.endDate
            ]
            that.$set(that.postForm, 'beginendDateArr', dateRange)
          }
        }
      }).then(_ => {
        loading.close()
      }).then(_ => {
        // that.$refs.formExtra.init()
      })
    },
    /** 保存 */
    handleSave() {
      this.$refs['postForm'].validate(valid => {
        if (valid) {
          const that = this
          var path = ''
          const loading = this.$loading(KxjCom.loadOptions)

          const postForm = {
            entityData: that.postForm,
            tempFiles: that.fileList
          }
          path = '/api/services/app/WorkTask/DoCheck'
          pathReq.dataUpdate(path, that.checkInfo).then(r => {
            if (!r.data.result) {
              that.$message.error('任务内容或跟进信息有更新,请重新确认后再编辑')
              that.handleOpen()
              // that.$refs.formExtra.init()
              return
            } else {
              path = '/api/services/app/WorkTask/CreateOrUpdateWorkTask'
              pathReq.dataUpdate(path, postForm).then(res => {
                that.$message.success('保存成功')
                this.$emit('save-success')
              }).then(_ => {
                that.$refs['postForm'].resetFields()
                // this.$refs.formExtra.clearData()
                this.dailogShow = false
              })
            }
          }).then(() => {
            loading.close()
          })
        }
      })
    },
    /** 日期变化 */
    handleDateChange() {
      if (this.postForm.beginendDateArr.length > 0) {
        this.postForm.beginDate = this.postForm.beginendDateArr[0]
        this.postForm.endDate = this.postForm.beginendDateArr[1]
      } else {
        this.postForm.beginDate = null
        this.postForm.endDate = null
      }
    }

  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  margin-top: 10px;
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 100% !important;
}
</style>
